import React from "react"
import * as style from "./style.module.scss"
function ProductHero(props: any) {
  return (
    <div className={`${style.productHeroStyles} overflow-hidden w-full`}>
      <div
        className={`${style.productHeroBanner} text-white hidden lg:block w-full`}
        style={{
          background: `url(${props?.backgroundImage?.filename})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className={`${style.introDataRight} pl-0 md:pl-30`}>
          <p className="text-4xl font-black font-expanded">
            {props.title}
          </p>
          <div className="w-9/12 font-bold">
            <p className="hidden lg:block">
              {props.description}
            </p>
            <p className="block lg:hidden">{props.description}</p>
          </div>
        </div>
      </div>
      <div
        className={`${style.productHeroBanner} text-white block lg:hidden w-full`}
        style={{
          background: `url(${props?.mobileBackgroundImage?.filename})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className={`${style.introDataRight} pl-0 md:pl-30 relative`}>
          <p className="text-4xl md:text-5xl font-black font-expanded">
            {props.title}
          </p>
          <div className="w-9/12 font-bold text-xl absolute top-[130vw]">
            <p className="hidden lg:block">
              {props.description}
            </p>
            <p className="block lg:hidden">{props.description}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductHero
